// The depth picked from Update now's menu, per forecast, for the life of the page. Both Update now
// buttons (the forecast header's and the latest-forecast card's) run at it, and the header shows
// it; it lives outside the header, which unmounts whenever no forecast is open.

let picks = {};
const listeners = new Set();

/** Records `tier` as the depth Update now runs forecast `id` at. */
export function pickDepth(id, tier) {
  picks = { ...picks, [id]: tier };
  for (const listener of listeners) listener();
}

/** The depth picked for forecast `id`, or undefined when none was. */
export function pickedDepthOf(id) {
  return picks[id];
}

/** Every pick by forecast id: the snapshot useSyncExternalStore reads. */
export function readPicks() {
  return picks;
}

/** useSyncExternalStore's subscribe for the picks. */
export function subscribePicks(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
